(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 1030px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      // Immediate response with minimal debouncing
      if (this.scrollTimeout) {
        clearTimeout(this.scrollTimeout);
      }

      this.scrollTimeout = setTimeout(() => {
        const scrollDelta = scrollTop - this.currentScrollTop;
        const isScrollingDown = scrollDelta > 0;
        const isScrollingUp = scrollDelta < 0;
        // Trigger much faster - at just 2px scroll
        const hasScrolledPastHeader = scrollTop > 2;

        // Always update the scrolled-past-header class regardless of search state
        if (hasScrolledPastHeader) {
          this.header.classList.add('scrolled-past-header');
        } else {
          this.header.classList.remove('scrolled-past-header');
        }

        // Only prevent hide/reveal animations when search is open
        if (this.predictiveSearch && this.predictiveSearch.isOpen) {
          this.currentScrollTop = scrollTop;
          return;
        }

        // Reduced threshold for more responsive feel
        if (Math.abs(scrollDelta) > 1) {
          if (hasScrolledPastHeader) {
            if (isScrollingDown && !this.preventHide) {
              requestAnimationFrame(this.hide.bind(this));
            } else if (isScrollingUp && !this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            }
          } else {
            requestAnimationFrame(this.reset.bind(this));
          }
        }

        this.currentScrollTop = scrollTop;
      }, 1);
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      if (!this.header.classList.contains('shopify-section-header-hidden')) {
        this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
        this.closeMenuDisclosure();
        this.closeSearchModal();
      }
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      if (this.header.classList.contains('shopify-section-header-hidden')) {
        this.header.classList.remove('shopify-section-header-hidden');
        this.header.classList.add('shopify-section-header-sticky', 'animate');
      }
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      if (this.header.classList.contains('shopify-section-header-sticky') || this.header.classList.contains('shopify-section-header-hidden')) {
        this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
